// @flow
import React, {Component} from 'react'
import {connect} from 'react-redux'
import moment from 'moment';
import {Row, Col, Tabs, Input, Card, Icon, Spin, message} from 'antd'
import PositionOverView from './PositionOverView'
import RiskProfileComponent from '../view-trades/risk-profile'
import RecordsView from '../view-trades/RecordsView'
import ApiService from '../../actions/apiService'
import {StyledContent} from './style'
const TabPane = Tabs.TabPane

class OwnPositions extends Component {
  
  state = {
    tradeId: this.props.match.params.id,
    isTradeNameEdit: this.props.match.params.id === 'new',
    tradeName: '',
    activeTab: this.props.match.params.tab || 'overview',
    tradeData: null,
  }
  
  async componentWillMount() {
    const {account} = this.props;
    const tradeId = this.props.match.params.id;
    try {
      if (tradeId !== 'new') {
        this.setState({
          isLoading: true,
        });
        const data = {
          'Account': account || 'all',
          TradeID: tradeId,
        };
    
        const response = await ApiService.getTrades(data);
        if (response) {
          const tradeData = response.find(x => x.tradeID === tradeId);
          if (tradeData) {
            this.setState({
              tradeData,
              isLoading: false,
              tradeName: tradeData.name,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        } else {
          this.setState({
            isLoading: false,
          });
        }
      }
    } catch(err) {
      this.setState({
        isLoading: false,
      });
    }
  }
  
  onInputChange= (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }
  
  onTabChange = (activeTab) => {
    this.setState({
      activeTab,
    });
    const tradeId = this.props.match.params.id;
    this.props.history.push(`/trades${tradeId && tradeId !== 'new' ? `/${tradeId}` : ''}/${activeTab}`);
  }
  
  setCurrentTrade = (tradeObj) => {
    let {tradeData, tradeName} = this.state;
    if (!tradeData) {
      tradeData = {};
    }
    tradeData.transactions = tradeObj.transactions.map((t) => {
    return {
      expiration: moment(t.Expiration).format('YYYY-MM-DD'),
      price: parseFloat(t.Price || 0),
      action: t.Action,
      strike: parseFloat(t.Strike || 0),
      quantity: t.Quantity,
      transactionGroup: t.TransactionGroup,
      commission: parseFloat(t.Commission || 0),
      tradeDate: t.TradeDate ? moment(t.TradeDate).format('YYYY-MM-DD') : null,
      underlying: t.Underlying,
      assetType: t.AssetType === '0' ? 'Call' : 'Put',
      underlyingPrice: parseFloat(t.UnderlyingPrice || t.price || 0),
      mark: parseFloat(t.marketPrice || 0),
      multipliper: parseInt(t.Multiplier || 100),
      symbol: t.Symbol,
    }});
    tradeData.openDate = tradeData.openDate ? tradeData.openDate : moment();
    tradeData.tradeName = tradeName;
    this.setState({
      tradeData: null,
    }, () => {
      this.setState({
        tradeData: tradeData,
      })
    })
  }

  onTradeNameSave = async () => {
    const data = {
      TradeID: this.props.match.params.id,
      Name: this.state.tradeName,
    }
    const response = await ApiService.postMethod('/account/addupdatetrade', data);
    if (response !== null) {
      message.success('Trade saved successfully');
    } else {
      message.error('Error while saving trade');
    }
  }
  
  render() {
    const {isLoading, tradeName, isTradeNameEdit, tradeData, tradeId, activeTab} = this.state;
    const {hasWriteAccess} = this.props;
    return (
      <StyledContent>
        {
          isLoading ?
            <div style={{padding: 100, textAlign: 'center'}}><Spin size="lg" /></div> :
            <Card title={
              <h1 className="title">
                {
                  !isTradeNameEdit ? [tradeName, hasWriteAccess && <Icon onClick={() => this.onInputChange({target: {name: 'isTradeNameEdit', value: !isTradeNameEdit }})} type="edit" />] :
                    [<Input value={tradeName} className="tradeName" name="tradeName" onChange={this.onInputChange} style={{width: '100%'}} />,
                      <Icon onClick={this.onTradeNameSave} type="save" />]
                }
              </h1>
            }>
              <Row>
                <Col span={24}>
                  <Tabs className="tabs" onChange={this.onTabChange} activeKey={activeTab}>
                    <TabPane tab='Overview' key='overview'>
                      <PositionOverView tradeId={this.props.match.params.id} tradeData={tradeData} tradeName={tradeName} setCurrentTrade={this.setCurrentTrade} hasWriteAccess={hasWriteAccess}/>
                    </TabPane>
                    {
                     tradeData &&
                      <TabPane tab='Risk Profile' key='risk-profile'>
                        { tradeData && <RiskProfileComponent selectedTrade={tradeData} />}
                      </TabPane>
                    }
                    {
                     tradeId && tradeId !== 'new' &&
                      <TabPane tab='Trade Notes' key='trade-notes'>
                        <RecordsView tradeId={this.props.match.params.id} hasWriteAccess={hasWriteAccess}/>
                      </TabPane>
                    }
                  </Tabs>
                </Col>
              </Row>
            </Card>
        }
      </StyledContent>
    
    )
  }
}

const mapStateToProps = (state: Object) => ({
  account: state.account.selectedAccount,
  hasWriteAccess: state.account.hasWriteAccess || false,
})

export default connect(mapStateToProps, null)(OwnPositions)



// WEBPACK FOOTER //
// ./src/components/own-positions/index.js